// extracted by mini-css-extract-plugin
module.exports =  {"tab":"TabButton-LVzF__tab","tab--active":"TabButton-q3XE__tab--active","badge":"TabButton-CLi___badge"};